module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dWaV1s/tc-custom/9781605098814.jpg?1704717895140",
      "alt": "This image is the cover for the book How to Get Ideas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Get Ideas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This new expanded second edition shows you—no matter your age or skill, your job or training—how to come up with more ideas, faster and easier.")]), _c('br'), _c('br'), _vm._v(" Jack Foster’s simple five-step technique for solving problems and getting ideas takes the mystery and anxiety out of the idea-generating process. It’s a proven process that works. You’ll learn to condition your mind to become “idea-prone,” utilize your sense of humor, develop your curiosity, visualize your goals, rethink your thinking, and overcome your fear of rejection."), _c('br'), _c('br'), _vm._v(" This expanded edition of the inspiring and enlightening classic features new information on how to turn failures to your advantage and how to create a rich, idea-inducing environment. Dozens of new examples and real-life stories show that anyone can learn to get more and better ideas.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Foster, Larry Corby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jack Foster spent thirty-five years working in creative departments of major advertising agencies; the first ten as a writer, the last 25 as a creative director. He has helped create advertising for scores of companies including Carnation, Mazda, Sunkist, Mattel, Albertson's, Ore-Ida, Suzuki, Universal Studios, Rand McNally, and Smokey Bear. He is a recipient of the Los Angeles Creative Club’s  \"Creative Person of the Year\" award.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Berrett-Koehler Publishers, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0